exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-item-check-print .list-content {\n  margin-top: 20px;\n  height: 400px;\n  overflow-y: auto;\n}\n.list-item-check-print .list-content .field {\n  background-color: #F2F3F4;\n  border-spacing: 30px;\n  border-collapse: separate;\n}\n.list-item-check-print .list-content .field:not(:last-child) {\n  margin: 0;\n}\n.list-item-check-print .list-content .field .b-checkbox {\n  border-radius: 0;\n  width: 100%;\n}", ""]);

// exports
